/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.product__media button.deferred-media__poster');

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.click();
                observer.unobserve(entry.target); // Stop observing after clicking
            }
        });
    }, { threshold: 0.5 }); // Trigger when at least 50% of the button is visible

    buttons.forEach(button => observer.observe(button));
  });


  const toggle = document.getElementById("unitToggle");

  /* convert all kg tr td */
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('tr[data-unit="kg"]').forEach(row => {
      row.querySelectorAll('td').forEach(td => {
        let text = td.textContent.trim();

        // Check if it's an integer
        if (/^\d+$/.test(text)) {
          let kg = parseInt(text, 10);
          let lb = Math.round(kg * 2.20462); // Convert kg to pounds

          // Replace content with span-wrapped units
          td.innerHTML = `<span class="unit-kg">${kg}</span><span class="unit-lb">${lb}</span>`;
        }
      });
    });

    /* convert cm to inch */
    function convertCmToInch(element) {
      let text = element.textContent.trim();

      // Check if it's a whole number
      if (/^\d+$/.test(text)) {
        let cm = parseInt(text, 10);
        let inch = Math.round(cm * 0.393701); // Convert cm to inches

        // Replace content with span-wrapped units
        element.innerHTML = `<span class="unit-cm">${cm}</span><span class="unit-in">${inch}</span>`;
      }
    }

    // Convert <td> elements inside tables with data-unit="cm"
    document.querySelectorAll('table[data-unit="cm"] td').forEach(convertCmToInch);

    // Convert <th> elements with data-unit="cm"
    document.querySelectorAll('th[data-unit="cm"]').forEach(convertCmToInch);
    

    const unit_cm = document.querySelectorAll('.unit-cm');
    const unit_kg = document.querySelectorAll('.unit-kg');
    const unit_in = document.querySelectorAll('.unit-in');
    const unit_lb = document.querySelectorAll('.unit-lb');

    if (toggle) {
      toggle.addEventListener("change", function () {
        
        if (toggle.checked) {
          unit_cm.forEach(unit => {
            unit.style.display = "none"
          });
          unit_kg.forEach(unit => {
            unit.style.display = "none"
          });
          unit_in.forEach(unit => {
            unit.style.display = "inline-block"
          });
          unit_lb.forEach(unit => {
            unit.style.display = "inline-block"
          });
          
        } else {
          unit_cm.forEach(unit => {
            unit.style.display = "inline-block"
          });
          unit_kg.forEach(unit => {
            unit.style.display = "inline-block"
          });
          unit_in.forEach(unit => {
            unit.style.display = "none"
          });
          unit_lb.forEach(unit => {
            unit.style.display = "none"
          });
        }
      });
    }
  });

  
  document.querySelectorAll('.rte__table-wrapper').forEach(wrapper => {
    wrapper.addEventListener('touchstart', () => {
        wrapper.style.overflow = 'hidden';
    });
  
    wrapper.addEventListener('touchend', () => {
        wrapper.style.overflow = 'auto';
    });
  });


  /* Product mobile thumb */
  document.addEventListener("DOMContentLoaded", function () {
    // Function to handle thumbnail click event
    function handleThumbnailClick(event) {
        // Check screen width
        if (window.innerWidth < 749) {
            const mediaId = event.currentTarget.getAttribute("data-media-id");
            const slidesContainer = document.querySelector(".product__slides");
            const targetSlide = document.querySelector(`.product__slide[data-media-id="${mediaId}"]`);

            if (slidesContainer && targetSlide) {
                // Scroll the target slide into view
                slidesContainer.scrollTo({
                    left: targetSlide.offsetLeft,
                    behavior: "smooth"
                });
            }
        }
    }

    // Attach event listeners to all product thumbnail links
    document.querySelectorAll(".product__thumb__link").forEach(thumbnail => {
        thumbnail.addEventListener("click", handleThumbnailClick);
    });
});





  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
